/* Stabiler Video-Host (Kiosk und Leitstand) */

.videoSlot {
  min-block-size: 360px;
  border-radius: var(--radius-m);
  background: #000;
}

.videoHost {
  position: fixed;
  z-index: 20;
  overflow: hidden;
  border-radius: var(--radius-m);
  background: #000;
}

.videoPip {
  position: fixed;
  z-index: 30;
  inset-block-end: var(--space-4);
  inset-inline-end: var(--space-4);
  overflow: hidden;
  inline-size: 320px;
  block-size: 200px;
  border-radius: var(--radius-m);
  background: #000;
  box-shadow: var(--shadow-l);
}

.videoFrame {
  display: block;
  inline-size: 100%;
  block-size: 100%;
  border: 0;
}

.devVideo {
  position: absolute;
  inset-block-start: var(--space-2);
  inset-inline-start: var(--space-2);
  padding-block: 2px;
  padding-inline: var(--space-2);
  border-radius: var(--radius-pill);
  background: var(--color-warning-bg);
  color: var(--color-warning-text);
  font-size: var(--text-xs);
  font-weight: 600;
}
